export default __webpack_public_path__ + "static/media/resource-icon.61e13e1a.svg";